module.exports = __webpack_public_path__ + "static/logo_nav-cb626fa43886551a7a91d6b0b3ea223b.png";